$(document).ready(function(){

  var $form = $('#styleathome');
  if ( $form.length > 0 ) {
    $('#styleathome-btn').bind('click', function ( event ) {
      if ( event ) event.preventDefault();
      if ( validateStyleHome($form) ) { registerStyleHome();
    }
  });
}

// Get all radio buttons with name "quiz_field-who"
var recipientRadios = document.querySelectorAll('input[name="quiz_field-who"]');
console.log('loaded');
recipientRadios.forEach(function (radio) {
  radio.addEventListener("change", function () {
    var selectedValue = document.querySelector('input[name="quiz_field-who"]:checked').value;
    // Select all matching elements
    document.querySelectorAll(".for-else").forEach(function (el) {
        el.style.display = selectedValue === "else" ? "inline" : "none";
    });
    document.querySelectorAll(".for-self").forEach(function (el) {
        el.style.display = selectedValue === "self" ? "inline" : "none";
    });
  });
});

$('#styleathome-form .step, #gifting-quiz .step').not('.one').hide();
$('#styleathome-form .step .btn.next, #gifting-quiz .step .btn.next').show();

$('#styleathome-form .step .btn.next, #gifting-quiz .step .btn.next').bind('click', function() {
  var $container = $("html,body");
  var $nextStep = $(this).parents('.step').next('.step');

  $nextStep.slideDown(500);
  $(this).fadeOut(100);

  if ($('header.header').hasClass('nav-hide')) {
    offsetAdjust = 40;
  } else {
    offsetAdjust = $('.header-holder').outerHeight() / 2;
  }
  $container.animate({scrollTop: ($nextStep.offset().top - offsetAdjust), scrollLeft: 0}, 700)
});
   
});//END READY

function validateStyleHome($form) {
  var email = $('#ContactFormEmail').val();
  var fname = $('#mce-FNAME').val();

  var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;

  if (filter.test(email)) {
    $('#styleathome-error').hide();
  }
  else {
    $('#styleathome-error').slideDown();
    $('#ContactFormEmail').addClass('error');
  }

  if (fname == "") {
    $('#styleathome-name-error').slideDown();
    $('#mce-FNAME').addClass('error');
  } 
  else {
    $('#styleathome-name-error').hide();
  }

  if ( (filter.test(email)) && ((fname =! "")) )
  {
   return true; 
  }
  else
  {
    return false;
  }
}
function registerStyleHome() {

  var FNAME = $('#mce-FNAME').val();
  var LNAME = $('#mce-LNAME').val();
  var EMAIL = $('#ContactFormEmail').val();
  var MMERGE6 = $("[name='MMERGE6']").val();
  var MMERGE8 = $("input[name='MMERGE8']:checked").val()
  var MMERGE10 = $("input[name='MMERGE10']:checked").val()
  var MMERGE9 = $("input[name='MMERGE9']:checked").val()
  var MMERGE11 = $("input[name='MMERGE11']:checked").val()
  var MMERGE12 = $("[name='MMERGE12']").val();
  var group20498 =[];
  var group20502 = [];
  var group20538 = [];


  $.each($("input[name='group[20498]']:checked"), function () {
    group20498.push(parseInt($(this).attr("value")));
   });
   $.each($("input[name='group[20502]']:checked"), function () {
    group20502.push(parseInt($(this).attr("value")));
   });
   $.each($("input[name='group[20538]']:checked"), function () {
    group20538.push(parseInt($(this).attr("value")));
   });


  var formdata = JSON.stringify({
    FNAME: FNAME, 
    LNAME: LNAME, 
    EMAIL: EMAIL, 
    MMERGE6: MMERGE6, 
    MMERGE8: MMERGE8, 
    MMERGE9: MMERGE9, 
    MMERGE10: MMERGE10,
    MMERGE11: MMERGE11,
    MMERGE12: MMERGE12,
    group20498: group20498,
    group20502: group20502,
    group20538: group20538
  });

    $.ajax({
        type: "POST",
        url: "https://gi3soemw5k.execute-api.eu-west-1.amazonaws.com/prod/stylist",
        data: formdata,
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
            if (!data) {
              $('#styleathomeerror').html(data);
              $('#styleathomeerror').slideDown();
            } else {
                $('#styleathome-form').hide();
                $('.intro .process').css('padding-top', 0);
                $('.intro .process li').hide();
                $('#styleathome-thanks').show();
                $("html,body").animate({scrollTop: ($('.form_wrapper').offset().top - 150), scrollLeft: 0}, 700)
            }
        }
    });
}
